export const analyticsId = {
  ECOMMERCE_CARD_STEP_1_VIEW: 'ECOMMERCE_CARD_STEP_1_VIEW',
  ECOMMERCE_CARD_STEP_2_VIEW: 'ECOMMERCE_CARD_STEP_2_VIEW',
  ECOMMERCE_CARD_STEP_3_VIEW: 'ECOMMERCE_CARD_STEP_3_VIEW',
  ECOMMERCE_CARD_WIZARD_ERROR: 'ECOMMERCE_CARD_WIZARD_ERROR',
  ECOMMERCE_CARD_WIZARD_SUCCESS: 'ECOMMERCE_CARD_WIZARD_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'banking',
  sectionCategory: 'products',
  sectionName: 'cards',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'contractingCard',
  detalleProceso: productName,
  productName,
});

export const catalogue = {
  [analyticsId.ECOMMERCE_CARD_STEP_1_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_precontractual',
    pageName: '/contractingCard/step1/precontractual',
    processStep: 'step1',
    processDetail: 'precontractual',
  }),
  [analyticsId.ECOMMERCE_CARD_STEP_2_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_configuration',
    pageName: '/contractingCard/step2/configuration',
    processStep: 'step2',
    processDetail: 'configuration',
  }),
  [analyticsId.ECOMMERCE_CARD_STEP_3_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_confirmation',
    pageName: '/contractingCard/step3/confirmation',
    processStep: 'step3',
    processDetail: 'confirmation',
  }),
  [analyticsId.ECOMMERCE_CARD_WIZARD_ERROR]: ({ errorMessage, productName }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/contractingCard/error',
    processStep: 'error',
    errorCategory: 'requestError',
    errorDescription: errorMessage,
  }),
  [analyticsId.ECOMMERCE_CARD_WIZARD_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/contractingCard/success',
    processStep: 'success',
  }),
};
